import { Layout, Menu } from "antd";

import dashboard from "../../assets/Category.svg";
import dashboard_blue from "../../assets/Category-blue.svg";
import dealerdashboard from "../../assets/dealerdashboard.png";
import dealerdashboard_blue from "../../assets/dashboard_blue.png";
import side_nav_bar_bg from "../../assets/side_nav_bar_bg.png";

import logout from "../../assets/Logout.svg";
import "./SideMenu.scss";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";

const { Sider } = Layout;
// const { SubMenu } = Menu;
function SideMenu() {
  const history = useHistory();
  const [selectedMenuItem, setSelectedMenuItem] = useState("1");

  useEffect(()=>{
    const item = localStorage.getItem("selected");
    item !== null ?
    setSelectedMenuItem(item) : setSelectedMenuItem("1")
  },[])

  return (
    <>
      <Sider>
        <Menu
          theme="light"
          selectedKeys={[selectedMenuItem]}
          mode="inline"
          style={{
            height: "100%",
            background: "#1D3954",
            backgroundImage: `url(${side_nav_bar_bg})`,
          }}
        >
          <Menu.ItemGroup
            key="g1"
            title={
              <p
                style={{
                  color: "#31A1E7",
                  fontWeight: "700",
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: "22px",
                  margin: "1rem 0",
                }}
              >
                Jotun - <span style={{ color: "white" }}>Admin</span>
              </p>
            }
          >
            <Menu.Item
              key="1"
              icon={
                selectedMenuItem === "1" ? (
                  <img src={dashboard_blue} alt="" />
                ) : (
                  <img src={dashboard} alt="" />
                )
              }
              onClick={() => {
                history.push("/search");
                setSelectedMenuItem("1");
                localStorage.setItem("selected","1")
              }}
            >
              Dashboard
            </Menu.Item>
            <Menu.Item
              key="2"
              icon={
                selectedMenuItem === "2" ? (
                  <img style={{height:22, width:22}} src={dealerdashboard_blue} alt="" />
                ) : (
                  <img style={{height:22, width:22}} src={dealerdashboard} alt="" />
                )
              }
              onClick={() => {
                history.push("/Dealer/search");
                setSelectedMenuItem("2");
                localStorage.setItem("selected","2")
              }}
            >
              DealerDashboard
            </Menu.Item>
            <div
              style={{
                position: "absolute",
                bottom: "80px",
                width: "100%",
                borderBottom: "1px solid #F1EDED",
                opacity: 0.1,
              }}
            />

            <Menu.Item
              style={{
                position: "absolute",
                bottom: "15px",
              }}
              key="6"
              icon={<img src={logout} alt="" />}
              onClick={() => {
                localStorage.clear();
                history.replace("/login");
              }}
            >
              Logout
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu>
      </Sider>
    </>
  );
}

export default SideMenu;
